import { type InputProps as Props } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import InputSection from '../InputSection/InputSection';

import styles from './SSNTextInput.scss';

interface InputProps extends Props {
  checkDisabled?: boolean;
}

const SSNTextInput: React.FC<InputProps> = ({ ...props }) => (
  <div className={classNames(styles.ssnGroup)}>
    <InputSection {...props} id="ssn1" length={3} placeholder="000" />
    <div className={classNames(styles.ssnDash)}> - </div>
    <InputSection {...props} id="ssn2" length={2} placeholder="00" />
    <div className={classNames(styles.ssnDash)}> - </div>
    <InputSection {...props} id="ssn3" length={4} placeholder="0000" />
  </div>
);

export default SSNTextInput;
